import { useQuery } from '@tanstack/react-query';

import { fetchCustAccessorialByCargoType } from '../data-provider/accessorials';
import type { GetCustAccessorialRequestParams } from '../data-provider/accessorials/api';

type Params = GetCustAccessorialRequestParams['inlineSearch'];

export const useGetCustAccessorials = ({ enabled, params }: { params: Params; enabled: boolean }) => {
  return useQuery({
    enabled: enabled && Boolean(params?.CustomerKey) && Boolean(params?.CargoType),
    queryFn: () => fetchCustAccessorialByCargoType({ inlineSearch: params } as GetCustAccessorialRequestParams),
    queryKey: ['master-data-get-cust-accessorial', params?.CustomerKey, params?.CargoType],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
